import { render, staticRenderFns } from "./baseball-data.vue?vue&type=template&id=2d95c26c&scoped=true&"
import script from "./baseball-data.vue?vue&type=script&lang=js&"
export * from "./baseball-data.vue?vue&type=script&lang=js&"
import style0 from "./baseball-data.vue?vue&type=style&index=0&id=2d95c26c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95c26c",
  null
  
)

export default component.exports